import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetPlanVarDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_PLANVAR_DETAILS, token);
  return res;
};

export const GetPlanVar = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_PLANVAR_DETAILS_BY_ID + id, token);
  return res;
};

export const AddPlanVar = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_PLANVAR, payload, token);
  return res;
};

export const DeletePlanVar = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_PLANVAR + id, id, token);
  return res;
};

export const UpdatePlan = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_PLANVAR + payload.id, payload, token);
  return res;
};
